import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import IssuePage from '../components/Issue/IssuePage';
import UserPrompt from '../components/UserPrompt';
import { getQR, listQRs, updateQR } from '../actions/api/apis';
import { OPEN_USER_PROMPT } from '../actions/actionTypes';

const style = {
  main: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
};

class IssueContainer extends Component {
  constructor(props) {
    super(props);
    const apiToken = props && props.apiToken;
    const dispatch = props && props.dispatch;
    dispatch({ type: 'CLOSE_MENU' });
    dispatch({ type: 'RESET_OPERATOR_INFO' });
    dispatch(listQRs(apiToken));
  }

  shouldComponentUpdate(props) {
    const createRequest = props && props.createRequest;
    const codeLists = props && props.codeLists;
    const apiToken = props && props.apiToken;
    const dispatch = props && props.dispatch;
    const currentCodeList = props && props.currentCodeList;
    const updateIssueContainer = props && props.updateIssueContainer;
    const showUserPrompt = props && props.showUserPrompt;
    if (updateIssueContainer) {
      dispatch(listQRs(apiToken));
    }
    if (!showUserPrompt && createRequest) {
      // 新規作成のリクエストがあったとき
      dispatch(getQR(apiToken, null));
    } else {
      const codeId = (codeLists.length > 0 && codeLists[0].codeId) || null;
      if (codeId && currentCodeList && !currentCodeList.codeId) {
        // 有効期限内のQRが1件以上存在してるが表示用情報(currentCodeList)が作られていない
        if (!showUserPrompt) {
          dispatch(getQR(apiToken, codeId));
        }
      }
    }
    return true;
  }

  render() {
    const {
      isMobile,
      openUserInfo,
      userInfo,
      license,
      apiToken,
      isLogin,
      isLoading,
      loadingMessages,
      currentCodeList,
      expireDateTime,
      expireDateTimeError,
      updatableDate,
      menuIsOpen,
      version,
      callingRooms,
      allowRemoteSupport,
      dispatch,
      innerRole,
      incomingAlertTarget,
      callingRoomsMembers,
      isCompanyAdmin,
    } = this.props;
    return (
      (!isLogin && <Redirect to="/login" />) || (
        <div style={style.main}>
          <IssuePage
            isMobile={isMobile}
            apiToken={apiToken}
            openUserInfo={openUserInfo}
            userInfo={userInfo}
            license={license}
            currentCodeList={currentCodeList}
            expireDateTime={expireDateTime}
            expireDateTimeError={expireDateTimeError}
            updatableDate={updatableDate}
            isLoading={isLoading}
            loadingMessages={loadingMessages}
            menuIsOpen={menuIsOpen}
            onExpire={(promptMessage, buttonArray) => {
              const onAccept = ans => {
                if (ans === 0) {
                  // expiresAtを5分前の日時にすることで削除扱いとする
                  const param = moment().subtract(5, 'm').valueOf().toString();
                  dispatch(updateQR(apiToken, currentCodeList.codeId, param));
                }
              };
              dispatch({
                type: OPEN_USER_PROMPT,
                promptMessage,
                buttonArray,
                onAccept,
              });
            }}
            version={version}
            callingRooms={callingRooms}
            allowRemoteSupport={allowRemoteSupport}
            innerRole={innerRole}
            dispatch={dispatch}
            incomingAlertTarget={incomingAlertTarget}
            callingRoomsMembers={callingRoomsMembers}
            isCompanyAdmin={isCompanyAdmin}
          />
          <UserPrompt />
        </div>
      )
    );
  }
}

IssueContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  openUserInfo: PropTypes.bool.isRequired,
  userInfo: PropTypes.object.isRequired,
  license: PropTypes.object.isRequired,
  apiToken: PropTypes.string.isRequired,
  isLogin: PropTypes.bool.isRequired,
  createRequest: PropTypes.bool.isRequired,
  codeLists: PropTypes.array.isRequired,
  currentCodeList: PropTypes.object.isRequired,
  expireDateTime: PropTypes.string.isRequired,
  expireDateTimeError: PropTypes.bool.isRequired,
  updatableDate: PropTypes.string.isRequired,
  updateIssueContainer: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadingMessages: PropTypes.array.isRequired,
  menuIsOpen: PropTypes.bool.isRequired,
  showUserPrompt: PropTypes.bool.isRequired,
  version: PropTypes.object.isRequired,
  callingRooms: PropTypes.array.isRequired,
  allowRemoteSupport: PropTypes.bool.isRequired,
  innerRole: PropTypes.number.isRequired,
  incomingAlertTarget: PropTypes.object.isRequired,
  callingRoomsMembers: PropTypes.array.isRequired,
  isCompanyAdmin: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isMobile: state.main.isMobile,
  openUserInfo: state.main.openUserInfo,
  userInfo: state.main.userInfo,
  license: state.main.license,
  apiToken: state.main.apiToken,
  isLogin: state.main.isLogin,
  isLoading: state.main.isLoading,
  loadingMessages: state.main.loadingMessages,
  createRequest: state.issue.createRequest,
  codeLists: state.issue.codeLists,
  currentCodeList: state.issue.currentCodeList,
  expireDateTime: state.issue.expireDateTime,
  expireDateTimeError: state.issue.expireDateTimeError,
  updatableDate: state.issue.updatableDate,
  updateIssueContainer: state.issue.updateIssueContainer,
  showUserPrompt: state.userPrompt.showUserPrompt,
  menuIsOpen: state.main.menuIsOpen,
  version: state.main.version,
  callingRooms: state.room.callingRooms,
  allowRemoteSupport: state.main.allowRemoteSupport,
  innerRole: state.main.innerRole,
  incomingAlertTarget: state.room.incomingAlertTarget,
  callingRoomsMembers: state.room.callingRoomsMembers,
  isCompanyAdmin: state.main.isCompanyAdmin,
});

export default connect(mapStateToProps)(IssueContainer);
